/* istanbul ignore file */

// The default minimum required age to order the bundle in any country.
export const DEFAULT_MINIMUM_AGE_TO_SUBSCRIBE = 18;
